import { create } from 'zustand';

export const useTrayStore = create<{
  show: boolean;
  setShow: (show: boolean) => void;
}>()((set) => ({
  show: false,
  setShow: (show) => set({ show })
}));
